declare namespace $ {

	export class $mol_icon_open_source_initiative extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=initiative.view.tree.d.ts.map